<!--  -->
<template>
  <div class="agreement_c">
    <div class="main_title">神州邦邦平台服务协议</div>
    <div class="sub_title">第一章 提示条款</div>
    <div class="main_item">
      <p>
        欢迎您与神州邦邦平台（详见第二章定义条款）共同签署本《神州邦邦平台服务协议》（下称“本协议”）并使用神州邦邦平台服务！
      </p>
      <p>
        您在申请注册流程中点击或选择同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体下划线标识，您应重点阅读（未成年人应在法定监护人陪同下审阅）。如您对协议有任何疑问，可向神州邦邦平台客服咨询。
      </p>
      <p>
        当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与神州邦邦平台达成一致，成为神州邦邦平台用户。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序。
      </p>
    </div>
    <div class="sub_title" style="margin-top: 0.4rem">第二章 定义</div>
    <div class="main_item">
      <ul class="content_wrap1">
        <li>
          <p>
            神州邦邦平台：指运营主体为北京神州邦邦技术服务有限公司及其关联公司，为用户提供电子商务交易的网络平台，以下简称“平台”，平台网址<a
              href="www.shenzhoubb.com"
              >www.shenzhoubb.com</a
            >
            。
          </p>
        </li>
        <li>
          <p>
            神州邦邦：神州邦邦平台经营者的单位或合称，包括北京神州邦邦技术服务有限公司。
          </p>
        </li>
        <li>
          <p>
            神州邦邦平台服务：神州邦邦基于互联网，以包含神州邦邦平台网站、客户端等在内的各种形态（包括未来技术发展出现的新的服务形态）向您提供的各项服务。
          </p>
        </li>
        <li>
          <p>
            神州邦邦平台规则：包括在所有神州邦邦平台规则频道内已经发布及后续发布的全部协议、规则、解读、公告等内容以及各平台在圈子、帮助中心内发布的各类规则、实施细则、产品流程说明、公告等。
          </p>
        </li>
        <li>
          <p>
            神州邦邦平台用户：指在神州邦邦平台合法注册，接受并认可神州邦邦平台规则的自然人、法人或非法人组织，简称“用户”。
          </p>
        </li>
        <li>
          <p>
            同一用户：使用同一认证信息或经神州邦邦平台排查认定多个账户的实际控制人为同一人的，均视为同一用户。
          </p>
        </li>
        <li>
          <p>雇主：指在神州邦邦平台上进行需求发布或购买服务等的用户。</p>
        </li>
        <li>
          <p>
            工程师：是指通过神州邦邦平台参加竞标、销售服务、出售技能、服务雇主等，亦称“服务商”或“商家”。
          </p>
        </li>
      </ul>
    </div>
    <div class="sub_title" style="margin-top: 0.4rem">第三章 协议范围</div>
    <div class="main_item">
      <ul class="content_wrap1">
        <li>
          <p>签约主体</p>
          <p>
            本协议由您与神州邦邦平台经营者共同缔结，本协议对您与神州邦邦平台经营者均具有合同效力。神州邦邦平台经营者是指经营神州邦邦平台的各法律主体，您可随时查看神州邦邦平台各网站首页底部公示的证照信息以确定与您履约的神州邦邦主体。
          </p>
          <p>
            本协议项下，神州邦邦平台经营者可能根据神州邦邦平台的业务调整而发生变更，变更后的神州邦邦平台经营者与您共同履行本协议并向您提供服务，神州邦邦平台经营者的变更不会影响您本协议项下的权益。神州邦邦平台经营者还有可能因为提供新的神州邦邦平台服务而新增，如您使用新增的神州邦邦平台服务的，视为您同意新增的神州邦邦平台经营者与您共同履行本协议。发生争议时，您可根据您具体使用的服务及对您权益产生影响的具体行为对象确定与您履约的主体及争议相对方。
          </p>
        </li>
        <li>
          <p>补充协议</p>
          <p>
            由于互联网高速发展，您与神州邦邦平台签署的本协议列明的条款并不能完整罗列并覆盖您与神州邦邦平台所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，神州邦邦平台各项法律声明/政策、知识产权声明、隐私保护政策及神州邦邦平台规则均为本协议的补充协议，与本协议不可分割且具有同等法律效力。如您使用神州邦邦平台服务，视为您同意上述补充协议。
          </p>
        </li>
      </ul>
    </div>
    <div class="sub_title" style="margin-top: 0.4rem">
      第四章 账号注册、使用与注销
    </div>
    <div class="main_item">
      <ul class="content_wrap1">
        <li>
          <p>用户资格</p>
          <p>
            *您确认，在您开始注册程序使用神州邦邦平台服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力，具体是：
          </p>
          <ul class="content_wrap2">
            <li>
              <p>年满十八岁具备完全民事权利能力和民事行为能力的自然人；</p>
            </li>
            <li>
              <p>经过其监护人同意的无民事行为能力人或限制民事行为能力人；</p>
            </li>
            <li>
              <p>
                据中国法律法规成立并合法存在的机关、企事业单位、社团组织和其他组织。
              </p>
            </li>
          </ul>
          <p>
            若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。
          </p>
          <p>
            此外，您还需遵从国家相关法律法规，并确保您不是任何国家、国际组织或者地域实施的贸易限制、制裁或其他法律、规则限制的对象，否则您可能无法正常注册及使用神州邦邦平台服务。
          </p>
        </li>
        <li>
          <p>账户说明</p>
          <p>
            您应当确保账户是由您本人或您的合法授权人进行注册获得，而非冒用他人信息或未经合法授权以及其他非法方式进行注册获得。当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，您可获得神州邦邦平台账户并成为神州邦邦平台用户。
          </p>
          <p>
            您有权使用您设置或确认的神州邦邦平台昵称、邮箱、手机号码（以下简称“账户名称”）及您设置的密码（账户名称及密码合称“账户”）登录神州邦邦平台，由于您的账户关联您的个人信息及神州邦邦平台商业信息，您的账户仅限您本人使用。您应当对该账户的一切行为负责。如神州邦邦根据神州邦邦平台规则中约定的违约认定程序及标准判断您账户的使用可能危及您的账户安全及/或神州邦邦平台信息安全的，神州邦邦可拒绝提供相应服务或终止本协议。
          </p>
          <p>
            由于用户账户关联用户信用信息，仅当有法律明文规定、司法裁定或神州邦邦平台同意的情况下，您可进行账户的转让，除此之外的情况，神州邦邦平台不允许进行账户转让。您的账户一经转让，该账户项下权利义务一并转移。除此外，您的账户不得以任何方式转让，否则神州邦邦平台有权追究您的违约责任，且由此产生的一切责任均由您承担。
          </p>
          <p>
            作为神州邦邦平台经营者，为使您更好地使用神州邦邦平台的各项服务，保障您的账户安全，神州邦邦平台可要求您按神州邦邦平台规则要求及我国法律规定完成实名认证。神州邦邦平台用户账号归属以该账号实名认证信息为准，如您未进行实名认证的，将影响到您正常使用神州邦邦平台的各项服务和权益保障。
          </p>
          <p>
            账号因所属人不明的情况产生纠纷或其他因司法行政等国家公职部门工作要求的情况下，神州邦邦平台有权对账号进行锁定处理。因纠纷情况锁定导致的任何损失及责任由发生纠纷的双方共同承担，锁定账号中尚有余额，将退至账号绑定的银行卡。
          </p>
          <p>
            神州邦邦平台有权对满足特定条件的账户做出不活跃账户的判定，并对该账户予以回收处理，具体条件如下：
          </p>
          <ul class="content_wrap2">
            <li>
              <p>连续180天未登陆神州邦邦平台；</p>
            </li>
            <li>
              <p>不存在未到期的有效业务。</p>
            </li>
          </ul>
        </li>
        <li>
          <p>账户信息管理</p>
          <p>
            在使用神州邦邦平台服务时，您应当按神州邦邦平台页面的提示准确完整地提供您的信息（包括但不限于您的姓名及电子邮件地址、联系电话、联系地址等），以便神州邦邦平台或其他用户与您联系。您了解并同意，您有义务保持您提供信息的真实性及有效性。如您未提供准确完整的信息，将影响到您正常使用神州邦邦平台的各项服务和权益保障。
          </p>
          <p>
            您设置的神州邦邦平台账户昵称不得违反国家法律法规及神州邦邦平台规则关于账户昵称的管理规定，否则神州邦邦平台可回收您的神州邦邦平台账户昵称。您账户昵称的回收不影响您以邮箱、手机号码登录神州邦邦平台并使用神州邦邦平台服务。
          </p>
          <p>
            您可以对部分自身账号相关信息进行查询、更新、删除。平台提供部分自助查询、更新、删除信息的功能，自助路径详见《神州邦邦平台个人信息保护政策》。同时您也可通过神州邦邦平台官方客服热线400-676-3988要求神州邦邦平台客服提供相关信息的查询、更新、删除服务。
          </p>
          <p>
            您应当及时更新您提供的信息，在法律有明确规定要求神州邦邦平台作为平台服务提供者必须对部分用户（如平台工程师等）的信息进行核实的情况下，神州邦邦平台将依法不时地对您的信息进行检查核实，您应当配合提供最新、真实、完整、有效的信息。
          </p>
          <p>
            如神州邦邦平台按您最后一次提供的信息与您联系未果、您未按神州邦邦平台的要求及时提供信息、您提供的信息存在明显不实或行政司法机关核实您提供的信息无效的，您将承担因此对您自身、他人及神州邦邦平台造成的全部损失与不利后果。神州邦邦平台可向您发出询问或要求整改的通知，并要求您进行重新认证，直至中止、终止对您提供部分或全部神州邦邦平台服务，神州邦邦平台对此不承担责任。
          </p>
        </li>
        <li>
          <p>账户安全规范</p>
          <p>
            您的账户为您自行设置并由您保管，神州邦邦平台任何时候均不会主动要求您提供您的账户密码。因此，建议您务必保管好您的账户，并确保您在每个上网时段结束时退出登录并以正确步骤离开神州邦邦平台。
          </p>
          <p>
            账户因您自身原因泄露或因您遭受他人攻击（含您使用的计算机被他人侵入）、诈骗等行为导致的损失及后果，平台并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。
          </p>
          <p>
            除平台存在过错外，您应对您账户项下的所有行为结果（包括但不限于在线签署各类协议、发布信息、购买商品及服务及披露信息等）负责。
          </p>
          <p>
            如发现任何未经授权使用您账户登录神州邦邦平台或其他可能导致您账户遭窃、遗失的情况，建议您立即通知神州邦邦平台，并授权神州邦邦平台进行处理。您理解神州邦邦平台对您的任何请求采取行动均需要合理时间，且神州邦邦平台应您请求而采取的行动可能无法避免或阻止侵害后果的形成或扩大，除存在法定过错外，神州邦邦平台将不承担责任。
          </p>
        </li>
        <li>
          <p>账号注销</p>
          <p>
            您可以注销账号。您可以登录注销申请页自助发起注销申请，平台审核通过后为您注销账户；您也可通过神州邦邦平台官方客服热线400-676-3988要求神州邦邦平台客服提供账号注销服务。
          </p>
          <p>
            如您注销账号，请按照神州邦邦平台相关规定妥善处理资金、发票及在途交易等事宜。
          </p>
        </li>
      </ul>
    </div>
    <div class="sub_title" style="margin-top: 0.4rem">
      第五章 神州邦邦平台服务
    </div>
    <div class="main_item">
      <ul class="content_wrap1">
        <li>
          <p>
            您有权在神州邦邦平台上享受服务信息发布和推广、服务的交易、服务的评价、交易纠纷处理等服务。神州邦邦平台提供的服务内容众多，具体您可登录平台浏览。有关于神州邦邦平台服务的具体约束，由《神州邦邦平台服务规则》做进一步规定。
          </p>
        </li>
        <li>
          <p>服务信息发布和推广</p>
          <p>
            通过神州邦邦平台提供的服务，您有权通过文字、图片、视频、音频等形式在平台上发布服务信息、招揽和物色交易对象、以达成交易。
          </p>
          <p>
            您应当确保您对您在神州邦邦平台上发布服务享有相应的权利，您不得在平台上发布及/或提供以下信息：
          </p>
          <ul class="content_wrap2">
            <li>
              <p>国家禁止或限制的；</p>
            </li>
            <li>
              <p>侵犯他人知识产权或其它合法权益的；</p>
            </li>
            <li>
              <p>
                神州邦邦平台规则、公告、通知或各平台与您单独签署的协议中已明确说明不适合在平台上发布及/或提供的。
              </p>
            </li>
          </ul>
          <p>
            有关服务信息发布的具体约束，由《神州邦邦平台服务商信息发布或出售管理细则》做进一步规定。
          </p>
        </li>
        <li>
          <p>服务的交易</p>
          <p>
            通过神州邦邦平台提供的服务，您有权在平台进行服务的交易，完成服务的交付及交付后的款项收支，发票管理等行为。
          </p>
          <p>
            您不得违反《银行卡业务管理办法》使用银行卡，或利用信用卡套取现金；您不得在明知或应知他人可能盗刷银行卡情形下而与对方进行交易。
          </p>
          <p>
            您应当遵守诚实信用原则，确保您所交易的服务信息真实、与您实际发布的服务信息相符，并在交易过程中切实履行您的交易承诺。
          </p>
          <p>
            您应当维护神州邦邦平台市场良性竞争秩序，不得贬低、诋毁竞争对手，不得干扰神州邦邦平台上进行的任何交易、活动，不得以任何不正当方式提升或试图提升自身的信用度，不得以任何方式干扰或试图干扰神州邦邦平台的正常运作。
          </p>
          <p>您不得使用以下方式登录网站或破坏网站所提供的服务：</p>
          <ul class="content_wrap2">
            <li>
              <p>
                以任何机器人软件、蜘蛛软件、爬虫软件、刷屏软件或其它自动方式访问或登录神州邦邦平台；
              </p>
            </li>
            <li>
              <p>
                通过任何方式对本公司内部结构造成或可能造成不合理或不合比例的重大负荷的行为；
              </p>
            </li>
            <li>
              <p>
                通过任何方式干扰或试图干扰网站的正常工作或网站上进行的任何活动。
              </p>
              <p>
                您应当确保您对您在神州邦邦平台的交易内容的合法性，不得包含以下内容：
              </p>
              <p>1、国家禁止或限制的；</p>
              <p>2、侵犯他人知识产权或其它合法权益的；</p>
              <p>
                3、神州邦邦平台规则、公告、通知或各平台与您单独签署的协议中已明确说明不适合在平台上发布及/或提供的。
              </p>
              <p>
                依法纳税是每一个公民、企业应尽的义务，您应对销售额/营业额超过法定免征额部分及时、足额地向税务主管机关申报纳税。用户通过神州邦邦平台进行交易，应按照《神州邦邦平台发票开具规则》及《神州邦邦平台发票收取规则》办理发票开具和收取相关事宜。
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>服务的评价</p>
          <p>
            您有权在神州邦邦平台提供的评价系统中对与您达成交易的其他用户进行评价。
          </p>
          <p>
            您的所有评价行为应遵守神州邦邦平台规则的相关规定，评价内容应当客观真实，不应包含任何污言秽语、色情低俗、广告信息及法律法规与本协议列明的其他禁止性信息；您不应以不正当方式帮助他人提升信用或利用评价权利对其他用户实施威胁、敲诈勒索。神州邦邦平台可按照神州邦邦平台规则的相关规定对您实施上述行为所产生的评价信息进行删除或屏蔽。关于评价服务的具体约束，由《神州邦邦平台交易评价规则》做进一步规定。
          </p>
        </li>
        <li>
          <p>交易纠纷处理</p>
          <p>
            您在神州邦邦平台交易过程中与其他用户发生交易纠纷的，您或其他用户中任何一方均有权选择以下途径解决：
          </p>
          <ul class="content_wrap2">
            <li>
              <p>双方自主协商；</p>
            </li>
            <li>
              <p>使用神州邦邦平台提供的纠纷调处服务；</p>
            </li>
            <li>
              <p>请求消费者协会或者其他依法成立的调解组织调解；</p>
            </li>
            <li>
              <p>向有关行政部门投诉；</p>
            </li>
            <li>
              <p>根据与纠纷相对方达成的仲裁协议（如有）提请仲裁机构仲裁；</p>
            </li>
            <li>
              <p>向人民法院提起诉讼。</p>
            </li>
          </ul>
          <p>
            如用户将纠纷告知神州邦邦平台，或神州邦邦平台知悉纠纷情况的，神州邦邦平台有权通过电子邮件及电话联系向纠纷双方了解纠纷情况，并将所了解的情况通过电子邮件互相通知对方。
          </p>
          <p>
            如您依据神州邦邦平台规则使用神州邦邦平台的官方调解服务，则表示您认可并愿意履行神州邦邦平台的客服或评审人员（“调处方”）根据其所了解到的纠纷事实并依据神州邦邦平台规则所作出的调处决定（包括调整相关订单的交易状态、判断将款项的全部或部分支付给交易一方或双方等）。在神州邦邦平台调处决定作出前，您可选择上述三、四、五、六途径（下称“其他处理途径”）解决以中止神州邦邦平台的纠纷调处服务。如您对调处决定不满意，您仍有权采取其他处理途径解决纠纷。有关交易纠纷的具体约束，由《神州邦邦平台纠纷处理规则》做进一步规定。
          </p>
        </li>
        <li>
          <p>服务费用</p>
          <p>
            神州邦邦为神州邦邦平台向您提供的服务付出了大量的成本，因此神州邦邦平台会收取合理的费用，神州邦邦平台会明示收费的业务相关信息。如未来神州邦邦平台进行费用调整，神州邦邦平台会采取合理途径并以足够合理的期限提前通过法定程序并以本协议第九章约定的方式通知您，确保您有充分选择的权利。
          </p>
        </li>
        <li>
          <p>责任限制</p>
          <p>
            神州邦邦平台依照法律规定履行基础保障义务，但对于下述原因导致的合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，神州邦邦平台并不承担相应的违约责任：
          </p>
          <ul class="content_wrap2">
            <li>
              <p>
                因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；
              </p>
            </li>
            <li>
              <p>因电力供应故障、通讯网络故障等公共服务因素或第三人因素；</p>
            </li>
            <li>
              <p>
                在神州邦邦平台已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。
              </p>
            </li>
          </ul>
          <p>您应当明确了解并同意：</p>
          <ul class="content_wrap2">
            <li>
              <p>
                神州邦邦平台不能随时预见到任何技术上的问题或其他困难。该等困难可能会导致数据损失或其他服务中断。神州邦邦平台是在现有技术基础上提供的服务。神州邦邦平台不保证以下事项：
              </p>
              <p>（1）神州邦邦平台将符合您的要求；</p>
              <p>
                （2）神州邦邦平台不受干扰、能够及时提供、安全可靠或免于出错；
              </p>
              <p>（3）本服务使用权的取得结果是正确或可靠的。</p>
            </li>
            <li>
              <p>
                是否经由神州邦邦平台下载或取得任何资料，由您自行考虑、衡量并且自负风险，因下载任何资料而导致您电脑系统的任何损坏或资料流失，您应负完全责任。希望您在使用神州邦邦平台时，小心谨慎并运用常识。
              </p>
            </li>
            <li>
              <p>
                您经由神州邦邦平台取得的建议和资讯，无论其形式或表现，绝不构成本协议未明示规定的任何保证。
              </p>
            </li>
            <li>
              <p>
                基于以下原因而造成的利润、商誉、使用、资料损失或其它无形损失，神州邦邦平台不承担任何直接、间接、附带、特别、衍生性或惩罚性赔偿（即使神州邦邦平台已被告知前款赔偿的可能性）：
              </p>
              <p>（1）神州邦邦平台的使用或无法使用；</p>
              <p>（2）您的传输或资料遭到未获授权的存取或变更；</p>
              <p>（3）任何第三方之声明或行为；</p>
              <p>
                （4）神州邦邦平台在服务交易中为用户提供交易机会，推荐交易方；
              </p>
              <p>（5）神州邦邦平台其它相关事宜。</p>
            </li>
            <li>
              <p>
                神州邦邦平台提供与其它互联网上的网站或资源的链接，您可能会因此连结至其它运营商经营的网站，但不表示神州邦邦平台与这些运营商有任何关系。其它运营商经营的网站均由各经营者自行负责，不属于神州邦邦平台控制及负责范围之内。对于存在或来源于此类网站或资源的任何内容、广告、物品或其它资料，神州邦邦平台亦不予保证或负责。因使用或依赖任何此类网站或资源发布的或经由此类网站或资源获得的任何内容、物品或服务所产生的任何损害或损失，神州邦邦平台不负任何直接或间接的责任。
              </p>

              <p>
                神州邦邦平台仅仅向您提供神州邦邦平台服务，您了解神州邦邦平台上的信息系用户自行发布，且可能存在风险和瑕疵。神州邦邦平台将通过依法建立相关检查监控制度尽可能保障您在神州邦邦平台上的合法权益及良好体验。同时，鉴于神州邦邦平台在信息网络环境下信息与实际服务相分离的特点，神州邦邦平台无法逐一审查商品及/或服务的信息，无法逐一审查交易所涉及的服务的质量、安全以及合法性、真实性、准确性，对此您应谨慎判断（神州邦邦平台指定主体授权工程师进行的交易按照相关规定执行）。
              </p>
              <p>
                您理解并同意，在纠纷调处服务中，神州邦邦平台的客服、评审人员并非专业人士，仅能以普通人的认知对用户提交的凭证进行判断。因此，您同意调处方对纠纷
                调处决定免责。
              </p>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="sub_title" style="margin-top: 0.4rem">
      第六章 用户信息的保护与授权
    </div>
    <div class="main_item">
      <ul class="content_wrap1">
        <li>
          <p>用户信息的保护与授权</p>
          <p>
            神州邦邦平台非常重视用户个人信息（即能够独立或与其他信息结合后识别用户身份的信息）的保护，在您使用神州邦邦平台提供的服务时，您同意神州邦邦平台按照在神州邦邦平台上公布的《神州邦邦平台个人信息保护政策》收集、存储、使用、披露和保护您的个人信息。神州邦邦平台希望通过《神州邦邦平台个人信息保护政策》向您清楚地介绍神州邦邦平台对您个人信息的处理方式，因此神州邦邦平台建议您完整地阅读隐私保护政策，以帮助您更好地保护您的隐私。
          </p>
          <p>
            神州邦邦平台属于商业性网站，您的注册账户行为及在网站浏览过程中留下联系方式的行为视同您同意神州邦邦平台及其工作人员（含神州邦邦平台用户）向您发送商业性短信息或拨打商业性电话。如您明确表示拒绝接收的，神州邦邦平台将停止前述行为；神州邦邦平台将通过技术手段不断完善短信、电话防侵扰服务，如退订等服务。
          </p>
          <p>
            如您拒绝提供神州邦邦平台服务所需要的信息，将影响到神州邦邦平台向您提供正常服务。包括但不限于无法登陆平台，无法进行实名认证，无法进行企业认证、无法推送信息并及时联系用户、无法进行交易和其他需要相应信息支持的服务。
          </p>
        </li>
        <li>
          <p>非个人信息的保证与授权</p>
          <p>
            您声明并保证，您对您所发布的信息拥有相应、合法的权利。否则，神州邦邦平台可对您发布的信息依法或依本协议进行删除或屏蔽。
          </p>
          <p>您应当确保您所发布的信息不包含以下内容：</p>
          <ul class="content_wrap2">
            <li>
              <p>违反国家法律法规禁止性规定的；</p>
            </li>
            <li>
              <p>
                政治宣传、封建迷信、淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；
              </p>
            </li>
            <li>
              <p>欺诈、虚假、不准确或存在误导性的；</p>
            </li>
            <li>
              <p>侵犯他人知识产权或涉及第三方商业秘密及其他专有权利的；</p>
            </li>
            <li>
              <p>侮辱、诽谤、恐吓、涉及他人隐私等侵害他人合法权益的；</p>
            </li>
            <li>
              <p>
                存在可能破坏、篡改、删除、影响神州邦邦平台任何系统正常运行或未经授权秘密获取神州邦邦平台及其他用户的数据、个人资料的病毒、木马、爬虫等恶意软件、程序代码的；
              </p>
            </li>
            <li>
              <p>
                其他违背社会公共利益或公共道德或依据相关神州邦邦平台协议、规则的规定不适合在神州邦邦平台上发布的。
              </p>
            </li>
          </ul>
          <p>
            对于您提供、发布及在使用神州邦邦平台服务中形成的除个人信息外的文字、图片、视频、音频等非个人信息，在法律规定的保护期限内您免费授予神州邦邦平台及其关联公司获得全球排他的许可使用权利及再授权给其他第三方使用并可以自身名义对第三方侵权行为取证及提起诉讼的权利。您同意神州邦邦平台及其关联公司存储、使用、复制、修订、编辑、发布、展示、翻译、分发您的非个人信息或制作其派生作品，并以已知或日后开发的形式、媒体或技术将上述信息纳入其它作品内。
          </p>
        </li>
        <li>
          <p>神州邦邦平台信息保护</p>
          <p>
            未经神州邦邦平台书面允许，您不得将神州邦邦平台的任何资料以及在交易平台上所展示的任何信息作商业性利用（包括但不限于以复制、修改、翻译等形式制作衍生作品、分发或公开展示）。
          </p>
        </li>
      </ul>
    </div>
    <div class="sub_title" style="margin-top: 0.4rem">
      第七章 用户的违约及处理
    </div>
    <div class="main_item">
      <ul class="content_wrap1">
        <li>
          <p>违约认定</p>
          <p>发生如下情形之一的，视为您违约：</p>
          <ul class="content_wrap2">
            <li>
              <p>使用神州邦邦平台服务时违反有关法律法规规定的；</p>
            </li>
            <li>
              <p>
                违反本协议或本协议补充协议（即本协议第第三章第二条）约定的；
              </p>
            </li>
            <li>
              <p>
                存在用户或其他第三方通知神州邦邦平台，认为您或具体交易事项存在违法或不当行为，并提供相关证据。神州邦邦平台以普通非专业人员的知识水平标准对相关内容进行判别，可以明显认为这些内容或行为可能对他方或神州邦邦平台造成财务损失或承担法律责任的。
              </p>
            </li>
          </ul>
          <p>
            为适应电子商务发展和满足用户对高效优质服务的需求，您理解并同意，神州邦邦平台可在神州邦邦平台规则中约定违约认定的程序和标准。
          </p>
        </li>
        <li>
          <p>违约处理措施</p>
          <p>
            您在神州邦邦平台上发布的信息构成违约的，神州邦邦平台可根据相应规则立即对相应信息进行删除、屏蔽处理或对您的信息及/或服务进行下架、监管。
          </p>
          <p>
            您在神州邦邦平台上实施的行为，或虽未在神州邦邦平台上实施但对神州邦邦平台及其用户产生影响的行为构成违约的，神州邦邦平台可依据相应规则对您执行限制参加活动、中止向您提供部分或全部服务、进行必要处理等措施。
          </p>
          <p>
            神州邦邦平台可将对您上述违约行为处理措施信息以及其他经国家行政或司法机关生效法律文书确认的违法信息在神州邦邦平台上予以公示。
          </p>
          <p>(1)禁止线下交易</p>
          <p>
            a、线下交易：指需求方在神州邦邦平台获取工程师信息，在首次及后续在平台发生的交易过程中，引导或接受工程师在神州邦邦平台之外进行交易，包括不限于以下情形：
          </p>
          <p>
            （a）在平台已产生订单及后续过程中，需求方引导或接受工程师通过神州邦邦平台以外渠道下单交易（包含但不限于需求方通过非神州邦邦平台向工程师付款等），均属于实施线下交易；
          </p>
          <p>
            （b）需求方主动引导或接受，导致平台工程师脱离神州邦邦平台进行交易，但最终未实施的（包含但不限于引导工程师通过非神州邦邦平台收款等），均属于引导线下交易违规行为。
          </p>
          <p>处理措施：若需求方出现以上违规行为，将参照如下条款处理：</p>
          <p>
            1）引导线下交易的，神州邦邦平台有权对此需求方名下所有账号（包含以相同证件认证的或通过技术手段确认相关联的所有或部分账户），第一次限制操作30自然日，并按照平台的要求以书面形式承诺不会再次引导或实施线下交易的行为，对已经生成协议及后续服务的订单，平台将对资金、流程进行全程监管，对尚未产生协议或后续服务的订单，平台将暂时锁定订单状态，直至保证期结束（30自然日）；第二次直接冻结账户，终止后续服务的产生与提供。
          </p>
          <p>
            2）实施线下交易的，神州邦邦平台有权对此需求方名下（包含以相同证件认证的或通过技术手段确认相关联的所有或部分账户），第一次限制操作60天，并扣除需求方线下交易订单对应金额的30%（若需求方账户余额或托管费用不足以抵扣，则按照欠款状态，直至需求方补足欠款且限制期结束方可执行后续操作），并按照平台的要求以书面形式承诺不会再次引导或实施线下交易的行为；第二次冻结需求方名下与名下关联账户，扣除需求方线下交易订单对应金额的80%（若需求方账户余额或托管费用不足以抵扣，则按照欠款状态，直至需求方补足欠款）。并保留通过法律途径保护平台利益的权利。
          </p>
          <p>
            b、用户因线下交易造成的一切经济损失由用户自行承担，神州邦邦平台将不承担任何责任。
          </p>
          <p>(2)禁止引流交易</p>
          <p>引流交易指：需求方引导或引流工程师到其他平台进行交易的：</p>
          <p>a、需求方将工程师引流到其他平台进行交易的，无论工程师是否同意；</p>
          <p>b、其他抢占用户资源的行为。</p>
          <p>
            需求方进行引流交易的，神州邦邦平台有权对该需求方采取包括并不限于：账号冻结、终止服务与协议、法律诉讼等，并按照规则扣除相应费用。需求方因引流行为造成的一切经济损失由需求方自行承担，神州邦邦平台不承担任何法律责任。
          </p>
        </li>
        <li>
          <p>赔偿责任</p>
          <p>
            如您的行为使神州邦邦平台及/或其关联公司遭受损失（包括自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失），您应赔偿神州邦邦平台及/或其关联公司的上述全部损失。
          </p>
          <p>
            如您的行为使神州邦邦平台及/或其关联公司遭受第三人主张权利，神州邦邦平台及/或其关联公司可在对第三人承担金钱给付等义务后就全部损失向您追偿。
          </p>
          <p>
            如因您的行为使得第三人遭受损失或您怠于履行调处决定、神州邦邦平台及/或其关联公司出于社会公共利益保护或消费者权益保护目的，可从您的神州邦邦平台账户中划扣相应款项进行支付。如您的余额不足以支付相应款项的，您同意委托神州邦邦平台使用自有资金代您支付上述款项，您应当返还该部分费用并赔偿因此造成神州邦邦平台的全部损失。
          </p>
          <p>
            您同意神州邦邦平台划扣相应款项支付上述赔偿款项。如您账户中的款项不足以支付上述赔偿款项的，神州邦邦平台及/或关联公司可直接抵减您在神州邦邦平台及/或其关联公司其它协议项下的权益，并可继续追偿。
          </p>
        </li>
        <li>
          <p>特别约定</p>
          <p>
            如您向神州邦邦平台及/或其关联公司的雇员或顾问等提供实物、现金、现金等价物、劳务、旅游等价值明显超出正常商务洽谈范畴的利益，则可视为您存在商业贿赂行为。发生上述情形的，神州邦邦平台可立即终止与您的所有合作，并依据神州邦邦平台规则进行处理，涉及严重违法行为的，将移送司法机关处理。
          </p>
          <p>
            用户保证在使用神州邦邦平台过程中所获悉的属于神州邦邦平台及他方的且无法自公开渠道获得的文件及资料（包括但不限于商业秘密、公司计划、运营活动、财务信息、技术信息、经营信息及其他商业秘密）予以保密。未经该资料和文件的原提供方同意，用户不得向第三方泄露该商业秘密的全部或者部分内容。但法律、法规、行政规章另有规定或者双方另有约定的除外。
          </p>
          <p>
            如您因严重违约导致神州邦邦平台终止本协议时，出于维护平台秩序及保护消费者权益的目的，神州邦邦平台及/或其关联公司可对与您在其他协议项下的合作采取中止甚或终止协议的措施，并以本协议第九章约定的方式通知您。
          </p>
          <p>
            如神州邦邦平台与您签署的其他协议及神州邦邦平台及/或其关联公司与您签署的协议中明确约定了对您在本协议项下合作进行关联处理的情形，则神州邦邦平台出于维护平台秩序及保护消费者权益的目的，可在收到指令时中止甚至终止协议，并以本协议第九章约定的方式通知您。
          </p>
        </li>
      </ul>
    </div>
    <div class="sub_title" style="margin-top: 0.4rem">第八章 协议的变更</div>
    <div class="main_item">
      <p>
        神州邦邦平台可根据国家法律法规变化、神州邦邦平台商业模式的调整及维护交易秩序、保护消费者权益需要，不时修改本协议、补充协议，变更后的协议、补充协议（下称“变更事项”）将通过法定程序并以本协议第九章约定的方式通知您。
      </p>
      <p>
        如您不同意变更事项，您有权于变更事项确定的生效日前联系神州邦邦平台反馈意见。如反馈意见得以采纳，神州邦邦平台将酌情调整变更事项。
      </p>
      <p>
        如您对已生效的变更事项仍不同意的，您应当于变更事项确定的生效之日起停止使用神州邦邦平台服务，变更事项对您不产生效力；如您在变更事项生效后仍继续使用神州邦邦平台服务，则视为您同意已生效的变更事项。
      </p>
    </div>
    <div class="sub_title" style="margin-top: 0.4rem">第九章 通知</div>
    <div class="main_item">
      <ul class="content_wrap1">
        <li>
          <p>有效联系方式</p>
          <p>
            您在注册成为神州邦邦平台用户，并接受神州邦邦平台服务时，您应该向神州邦邦平台提供真实有效的联系方式（包括但不限于您的电子邮件地址、联系电话、联系地址等），对于联系方式发生变更的，您有义务及时更新有关信息，并保持可被联系的状态。
          </p>
          <p>
            您在注册神州邦邦平台用户时生成的用于登陆神州邦邦平台接收站内信、系统消息和即时信息的会员账号（包括子账号），也将视为您的有效联系方式。
          </p>
          <p>
            神州邦邦平台将向您的上述联系方式的其中之一或其中若干向您送达各类通知，而此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。
          </p>
          <p>
            您有权通过您注册时填写的手机号码或者电子邮箱获取您感兴趣的商品广告信息、促销优惠等商业性信息；您如果不愿意接收此类信息，您有权联系神州邦邦平台客服人员处理。
          </p>
        </li>
        <li>
          <p>通知的送达</p>
          <p>
            神州邦邦平台通过上述联系方式向您发出通知，其中以电子的方式发出的书面通知，包括但不限于在神州邦邦平台公告，向您提供的联系电话发送手机短信，向您提供的电子邮件地址发送电子邮件，向您的账号发送即时信息、系统消息以及站内信信息，在发送成功后即视为送达；以纸质载体发出的书面通知，按照提供联系地址交邮后的第五个自然日即视为送达。
          </p>
          <p>
            对于在神州邦邦平台上因交易活动引起的任何纠纷，您同意司法机关（包括但不限于人民法院）可以通过手机短信、电子邮件或即时信息等现代通讯方式或邮寄方式向您送达法律文书（包括但不限于诉讼文书）。您指定接收法律文书的手机号码、电子邮箱或神州邦邦平台账号等联系方式为您在神州邦邦平台注册、更新时提供的手机号码、电子邮箱联系方式以及在注册神州邦邦平台用户时生成神州邦邦平台账号，司法机关向上述联系方式发出法律文书即视为送达。您指定的邮寄地址为您的法定联系地址或您提供的有效联系地址。
          </p>
          <p>
            您同意司法机关可采取以上一种或多种送达方式向您达法律文书，司法机关采取多种方式向您送达法律文书，送达时间以上述送达方式中最先送达的为准。
          </p>
          <p>
            您同意上述送达方式适用于各个司法程序阶段。如进入诉讼程序的，包括但不限于一审、二审、再审、执行以及督促程序等。
          </p>
          <p>
            你应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由您自行承担由此可能产生的法律后果。
          </p>
        </li>
      </ul>
    </div>
    <div class="sub_title" style="margin-top: 0.4rem">第十章 协议的终止</div>
    <div class="main_item">
      <ul class="content_wrap1">
        <li>
          <p>终止的情形</p>
          <p>您有权通过以下任一方式终止本协议：</p>
          <ul class="content_wrap2">
            <li>
              <p>
                在满足神州邦邦平台公示的账户注销条件时您通过网站自助服务注销您的账户的；
              </p>
            </li>
            <li>
              <p>变更事项生效前您停止使用并明示不愿接受变更事项的；</p>
            </li>
            <li>
              <p>
                您明示不愿继续使用神州邦邦平台服务，且符合神州邦邦平台终止条件的。
              </p>
            </li>
          </ul>
          <p>
            出现以下情况时，神州邦邦平台可以本协议第九章的所列的方式通知您终止本协议：
          </p>
          <ul class="content_wrap2">
            <li>
              <p>您违反本协议约定，神州邦邦平台依据违约条款终止本协议的；</p>
            </li>
            <li>
              <p>
                您盗用他人账户、发布违禁信息、骗取他人财物、售假、扰乱市场秩序、采取不正当手段谋利等行为，神州邦邦平台依据神州邦邦平台规则对您的账户予以查封的；
              </p>
            </li>
            <li>
              <p>
                神州邦邦平台发现您的注册资料中主要内容是虚假的，神州邦邦平台有权随时终止本协议；
              </p>
            </li>
            <li>
              <p>
                除上述情形外，因您多次违反神州邦邦平台规则相关规定且情节严重，神州邦邦平台依据神州邦邦平台规则对您的账户予以查封的；
              </p>
            </li>
            <li>
              <p>您的账户被神州邦邦平台依据本协议回收的；</p>
            </li>
            <li>
              <p>
                您在神州邦邦平台有欺诈、发布或销售假冒伪劣/侵权商品、侵犯他人合法权益或其他严重违法违约行为的；
              </p>
            </li>
            <li>
              <p>其它应当终止服务的情况。</p>
            </li>
          </ul>
        </li>
        <li>
          <p>协议终止后的处理</p>
          <p>
            本协议终止后，除法律有明确规定外，神州邦邦平台无义务向您或您指定的第三方披露您账户中的任何信息。您再一次直接或间接或以他人名义注册为神州邦邦平台用户的，神州邦邦平台有权拒绝或者在注册成功后单方面再次终止本协议。
            本协议终止后，神州邦邦平台仍享有下列权利：
          </p>
          <ul class="content_wrap2">
            <li>
              <p>继续保存您留存于神州邦邦平台的本协议第六章所列的各类信息；</p>
            </li>
            <li>
              <p>
                对于您过往的违约行为，神州邦邦平台仍可依据本协议向您追究违约责任。
              </p>
              <p></p>
            </li>
          </ul>
          <p>
            本协议终止后，对于您在本协议存续期间产生的交易订单，神州邦邦平台可通知交易相对方并根据交易相对方的意愿决定是否关闭该等交易订单；如交易相对方要求继续履行的，则您应当就该等交易订单继续履行本协议及交易订单的约定，并承担因此产生的任何损失或增加的任何费用。
          </p>
        </li>
      </ul>
    </div>
    <div class="sub_title" style="margin-top: 0.4rem">
      第十一章 法律适用、管辖与其他
    </div>
    <div class="main_item">
      <p>
        本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律；如法律无相关规定的，参照商业惯例及/或行业惯例。
      </p>
      <p>
        您因使用神州邦邦平台服务所产生及与神州邦邦平台服务有关的争议，由神州邦邦平台与您协商解决。协商不成时，任何一方均可向北京仲裁委员会提起仲裁。
      </p>
      <p>
        本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。
      </p>
      <p>
        本协议自公布之日起生效并执行，神州邦邦平台对本服务协议包括基于本服务协议制定的各项规则拥有最终解释权。
      </p>
      <p>
        本协议第七章至第十一章约定的条款效力及于其他神州邦邦平台规则，对其他神州邦邦平台规则同等适用。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.sub_title {
  font-size: 0.3rem;
  text-align: center;
  font-weight: 900;
  padding: 0 0 0.4rem;
}
</style>